<template>
    <div class="employee-tab-inner">    

        <div class="">
            <div v-if="em_reg_settlement_list.length>0">
                <template v-if="$acl['pf/leaverlist'] > 1 ">
                    <common-list  :pageurl="this.$api_url"  :is_pf="is_n_pf"  :is_action="is_action" :appended_column="appended_column" :key="settlement_list_key" :company_options="company_options" :employees="em_reg_settlement_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="settlementListReturn"></common-list>
                </template>
                <template v-else>
                    <common-list  :pageurl="this.$api_url"  :is_pf="is_n_pf"  is_action=0 :appended_column="appended_column" :key="settlement_list_key" :company_options="company_options" :employees="em_reg_settlement_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="settlementListReturn"></common-list>
                </template>
                </div>
            <div v-else>

                <div v-if="settlement_loader" class="list-no-data">
                    <span class="d-block text-center">Looking for relevant data..</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="list-no-data">
                    Looks like there is no employee to show.
                </div>
                
            </div>
        </div>   
	
		<b-modal id="unsettle-modal" title="Are you sure you want to unsettle this process ?" hide-footer> 
			<br />
			<div style="height: 10px;clear:both;"> &nbsp;</div>
			<a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="unsettlePF(unsettle_pf_id)">Unsettle <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
			&nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('unsettle-modal')">Cancel</a>
			<div style="height: 5px;clear:both;"> &nbsp;</div>
		</b-modal>

        <div>
            <b-modal id="delete-payrun-modal" :title="payrun_delete_msg" hide-footer>Please enter your password to continue:
                <br />
                <input id="approvepass" type="password" class="form-control" v-model="approvepass" name="approvepass"> 

                <div v-if="incorrectpass != ''" class="alert alert-danger" role="alert" style="clear: both; margin-top: 10px;"> {{incorrectpass}} </div>
                <div style="height: 10px;clear:both;"> &nbsp;</div>
                <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="unsettlePF(unsettle_pf_id)">Unsettle <span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></a>
                &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-payrun-modal')">Cancel</a>
                <div style="height: 5px;clear:both;"> &nbsp;</div>
            
            </b-modal>
        </div>
		
    </div>
</template>


<script>
    
    export default{
        
        mounted() {
            
            this.showoverlay = false;
        },
        props: ['flg','pageurl'],
        components: {
           
        },
        data(){            
           
        
            return {
                
                settlement_loader:true,
                showoverlay : true,
                settlement_list:[],
                settlement_list_key:0,
                loading:'',
                curr_update_employee:'',
                min_date:'',
                curr_approve_date:"",
                is_n_pf:1,
                /**Child Component property data */

                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                em_reg_settlement_list:[],  /* Data List */
                default_column:['name','email','jobposition'], /* Default Column List */
                appended_column:[
                     
                    { value: "status", text: "Status",type: "text"},
                    // { value: "settlement_amount", text: "Settlement Amount",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "settlement_amount", text: "Settlement Amount",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "settlement_date", text: "Settlement Date",type: "date"},
                    ],                   /* Appended Column List  and there title and type */
                primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],

                /***Child Component property data */


                unsettle_pf_id:0,
                approvepass: '',
                incorrectpass: '',
                payrun_delete_msg:'',

    
            }
        },
        methods:{

            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },  

            settlementListReturn: function(data)
            {
                if(data.action_id==1)
                {
                    var item  = this.em_reg_settlement_list.find(item => item.id === data.id); 
                    
                    this.unsettle_pf_id = item.id;
                    //this.$bvModal.show('unsettle-modal');
                    this.approvepass="";
                    this.payrun_delete_msg="Are you sure to revert this settlement ?";
                    this.$bvModal.show('delete-payrun-modal'); 

                 
                }
            },
            
            unsettlePF: function(papflg){
                
                if(this.approvepass!='')
                 {
                     var pass=this.approvepass;  
    			     this.loading='load';
                 }
                let formData = new FormData();
                formData.append('pf_id',papflg);

                formData.append('pass',pass);

                axios.post(this.$api_url + '/pf/settlement/revert', formData)
                .then(function (response) 
                { 
                    
                    if(response.data.success==true){
                        this.$bvToast.toast(response.data.message, {
                            title: `Success !`,
                            variant: 'success',
                            solid: true
                        });
                    }else{
                        this.$bvToast.toast(response.data.success, {
                            title: `Error`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                    this.$emit('childToParent');
                    this.loading='';
                    this.$bvModal.hide('delete-payrun-modal');
                    this.pfSettlementList();
               }.bind(this));
            }, 
            pfSettlementList: function(index_name='employee_dropdown')
            {
                this.settlement_list = [];
                this.em_reg_settlement_list = [];
               
                let currentObj = this;
                currentObj.settlement_loader = true;
                axios.get(this.$api_url+'/pf/settlement/list' , {
                    params: {
								  settlement_list: 1
							}
    
                }).then(function(response){

                   
                

                //this.settlement_list = [];

                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */ 
                    this.settlement_list = response.data.employee_data;

                    /* Assingning the list */ 
                    this.settlement_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    this.company_options =  response.data.options;
                }
                if (typeof response.data.options !== 'undefined')
                {
                
                }
                

                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                

                if(this.settlement_list.length > 0 )
                {
                        let emp_ids = []; 
                        this.settlement_list.forEach(pelement => {
                            
                            let dops = []; 

                            let awating = []; 

                             
                            let ii = 0; 
                
                            if(pelement.employee_id > 0)
                            {
                                
                                if(!emp_ids.includes(pelement.employee_id))
                                {
                                    emp_ids.push(pelement.employee_id);
                                    dops = dops.concat([{ label: 'Unsettle' , value: 1 }]);
                                    

                                }
                                
                                pelement.actions = dops; 
                                pelement.pf_total = this.formatMoney(pelement.pf_total);
                                
                                
                                if(pelement.pf_end == '0000-00-00' || pelement.pf_end == '' || pelement.last_payslip == null)
                                {
                                    pelement.pf_end ='';
                                
                                    this.em_reg_settlement_list = this.em_reg_settlement_list.concat(pelement);
                                }
                                else
                                { 
                                    
                                    this.em_reg_settlement_list = this.em_reg_settlement_list.concat(pelement);
                                    

                                    ii++;

                                    
                                        
                                }

                                console.log(pelement.employee_id);
                            }
                            else
                            {
                               
                            }
                        });

                    
                }
                else
                {
                    this.blankmsg = "No employee found to De-Register";
                }
                
                //this.reg_custom_list = this.reg_tmp_custom_list;
                this.settlement_list_key = this.settlement_list_key + 1;
                
                currentObj.settlement_loader = false;
                }.bind(this)).catch(function (error){
                    currentObj.settlement_loader = false;
                    console.log(error)
                });
            },
            
        },
        created: function(){
          this.pfSettlementList();
        },
        computed: 
        {
            
        }
    }
</script>

